import { createSlice } from '@reduxjs/toolkit';
import { fetchBundles } from './utils';

/**
 * Redux slice for managing bundles state
 */
const bundlesSlice = createSlice({
  name: 'bundles',
  initialState: {
    availableBundles: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(fetchBundles.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchBundles.fulfilled, (state, action) => {
          state.loading = false;
          state.availableBundles = action.payload;
        })
        .addCase(fetchBundles.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
  }
});

export default bundlesSlice.reducer;
